const sfAuthProvider = {
    signin(callback: VoidFunction) {
        setTimeout(callback, 100);
    },
    signout(callback: VoidFunction) {
        setTimeout(callback, 100);
    },
};

export { sfAuthProvider };